import React, { useEffect } from 'react';
import { useTour } from './TourProvider';
import Dockie from "@/assets/dockie-preview.png"

const TourWelcome = () => {
  const { showWelcome, beginTour, endTour } = useTour();

  useEffect(() => {
  }, [showWelcome]);


  const handleBeginTour = () => {
    beginTour();
  };

  const handleEndTour = () => {
    endTour();
  };

  if (!showWelcome) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-2xl p-8 max-w-md mx-4 shadow-2xl">
        <div className="mb-6">
          <div className="w-full h-48 overflow-hidden rounded-lg mb-4 flex items-center justify-center">
            <img
              src={Dockie}
              alt="dockie-bot"
              className="w-full h-fit overflow-hidden"
            />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          Welcome to Dockie!
        </h2>

        <p className="text-gray-600 mb-6 leading-relaxed">
          Let's take a quick tour to show you the key features: your home
          dashboard, how to start new chats, and how to upload media files.
        </p>

        <div className="flex gap-3">
          <button
            onClick={handleBeginTour}
            className="flex-1 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            Start Tour
          </button>
          <button
            onClick={handleEndTour}
            className="px-6 py-3 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourWelcome;